import _get from "lodash/get";
import React, { useState, useEffect } from 'react';
import { useIdentityContext } from 'react-netlify-identity/dist';
import { buttonSkinData, buttonBtnTypeData } from '@luigiclaudio/ga-baseline-ui/button';
import { useLoading, Loader } from '@luigiclaudio/ga-baseline-ui/helpers';
import AuthResetPassword from './AuthResetPassword';
import AuthRecoverPassword from './AuthRecoverPassword';

var AuthRecoverResetFlow = function AuthRecoverResetFlow(_ref) {
  var location = _ref.location,
      buttonSkin = _ref.buttonSkin,
      buttonBtnType = _ref.buttonBtnType,
      showHeading = _ref.showHeading,
      loaderBackgroundColor = _ref.loaderBackgroundColor;
  var state = location.state;

  var _useLoading = useLoading(),
      isLoading = _useLoading[0],
      load = _useLoading[1];

  var _useIdentityContext = useIdentityContext(),
      user = _useIdentityContext.user,
      recoverAccount = _useIdentityContext.recoverAccount;

  var _useState = useState(),
      isResetInvalid = _useState[0],
      setIsResetInvalid = _useState[1];

  var _useState2 = useState(),
      recoverAccountErrorMessage = _useState2[0],
      setRecoverAccountErrorMessage = _useState2[1];

  var recoveryToken = _get(state, 'token');

  useEffect(function () {
    load(recoverAccount(recoveryToken, true)).then(function (res) {
      return res;
    }).catch(function (err) {
      setRecoverAccountErrorMessage(err.json);
    }); // eslint-disable-next-line
  }, [recoveryToken]);
  useEffect(function () {
    setIsResetInvalid(recoverAccountErrorMessage || !recoverAccountErrorMessage && !user || !recoveryToken);
  }, [user, recoverAccountErrorMessage, recoveryToken]);
  var renderForm = isResetInvalid ? /*#__PURE__*/React.createElement(AuthRecoverPassword, {
    buttonSkin: buttonSkin,
    buttonBtnType: buttonBtnType,
    showHeading: showHeading,
    isRecoverValid: false
  }) : /*#__PURE__*/React.createElement(AuthResetPassword, {
    buttonSkin: buttonSkin,
    buttonBtnType: buttonBtnType,
    showHeading: showHeading
  });
  return isLoading ? /*#__PURE__*/React.createElement(Loader, {
    isFullScreen: true,
    fullScreenBackgroundColor: loaderBackgroundColor
  }) : renderForm;
};

AuthRecoverResetFlow.defaultProps = {
  buttonSkin: 'primary',
  buttonBtnType: 'default',
  showHeading: true,
  loaderBackgroundColor: undefined
};
export default AuthRecoverResetFlow;